// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Agenda from "./agenda.js"
import AgendaItem from "./agenda-item.js"
import AgendaItemElement from "./agenda-item-element.js"
import Contact from "./contact.js"
import Election from "./election.js"
import Highscore from "./highscore.js"
import Product from "./product.js"
import RequiredMetadatum from "./required-metadatum.js"

const modelClassData = {
  "attributes": {
    "activity_surveys_count": {
      "column": {
        "default": 0,
        "name": "activity_surveys_count",
        "null": false,
        "type": "integer"
      },
      "name": "activity_surveys_count",
      "selected_by_default": null,
      "translated": null
    },
    "activity_type": {
      "column": {
        "default": "activity",
        "name": "activity_type",
        "null": false,
        "type": "string"
      },
      "name": "activity_type",
      "selected_by_default": null,
      "translated": null
    },
    "allow_public_sign_up": {
      "column": {
        "default": true,
        "name": "allow_public_sign_up",
        "null": false,
        "type": "boolean"
      },
      "name": "allow_public_sign_up",
      "selected_by_default": null,
      "translated": null
    },
    "authenticate_anonymously": {
      "column": {
        "default": true,
        "name": "authenticate_anonymously",
        "null": false,
        "type": "boolean"
      },
      "name": "authenticate_anonymously",
      "selected_by_default": null,
      "translated": null
    },
    "authenticate_with_uni_c": {
      "column": {
        "default": true,
        "name": "authenticate_with_uni_c",
        "null": false,
        "type": "boolean"
      },
      "name": "authenticate_with_uni_c",
      "selected_by_default": null,
      "translated": null
    },
    "authenticate_with_email": {
      "column": {
        "default": true,
        "name": "authenticate_with_email",
        "null": false,
        "type": "boolean"
      },
      "name": "authenticate_with_email",
      "selected_by_default": null,
      "translated": null
    },
    "auto_approve_participants": {
      "column": {
        "default": false,
        "name": "auto_approve_participants",
        "null": false,
        "type": "boolean"
      },
      "name": "auto_approve_participants",
      "selected_by_default": null,
      "translated": null
    },
    "cancellation_deadline_days": {
      "column": {
        "default": null,
        "name": "cancellation_deadline_days",
        "null": true,
        "type": "integer"
      },
      "name": "cancellation_deadline_days",
      "selected_by_default": null,
      "translated": null
    },
    "check_in_starts_at": {
      "column": {
        "default": null,
        "name": "check_in_starts_at",
        "null": true,
        "type": "datetime"
      },
      "name": "check_in_starts_at",
      "selected_by_default": null,
      "translated": null
    },
    "current_agenda_id": {
      "column": {
        "default": null,
        "name": "current_agenda_id",
        "null": true,
        "type": "uuid"
      },
      "name": "current_agenda_id",
      "selected_by_default": null,
      "translated": null
    },
    "current_agenda_item_id": {
      "column": {
        "default": null,
        "name": "current_agenda_item_id",
        "null": true,
        "type": "uuid"
      },
      "name": "current_agenda_item_id",
      "selected_by_default": null,
      "translated": null
    },
    "default_participant_type": {
      "column": {
        "default": "participant",
        "name": "default_participant_type",
        "null": false,
        "type": "string"
      },
      "name": "default_participant_type",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "description": {
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      },
      "name": "description",
      "selected_by_default": null,
      "translated": null
    },
    "election_description": {
      "column": {
        "default": null,
        "name": "election_description",
        "null": true,
        "type": "text"
      },
      "name": "election_description",
      "selected_by_default": null,
      "translated": null
    },
    "election_enabled": {
      "column": {
        "default": false,
        "name": "election_enabled",
        "null": false,
        "type": "boolean"
      },
      "name": "election_enabled",
      "selected_by_default": null,
      "translated": null
    },
    "election_title": {
      "column": {
        "default": null,
        "name": "election_title",
        "null": true,
        "type": "text"
      },
      "name": "election_title",
      "selected_by_default": null,
      "translated": null
    },
    "ends_at": {
      "column": {
        "default": null,
        "name": "ends_at",
        "null": true,
        "type": "datetime"
      },
      "name": "ends_at",
      "selected_by_default": null,
      "translated": null
    },
    "guests_per_participant": {
      "column": {
        "default": null,
        "name": "guests_per_participant",
        "null": true,
        "type": "integer"
      },
      "name": "guests_per_participant",
      "selected_by_default": null,
      "translated": null
    },
    "highscore_id": {
      "column": {
        "default": null,
        "name": "highscore_id",
        "null": true,
        "type": "uuid"
      },
      "name": "highscore_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "include_question_products_at_transmission": {
      "column": {
        "default": false,
        "name": "include_question_products_at_transmission",
        "null": false,
        "type": "boolean"
      },
      "name": "include_question_products_at_transmission",
      "selected_by_default": null,
      "translated": null
    },
    "instant_payment": {
      "column": {
        "default": false,
        "name": "instant_payment",
        "null": false,
        "type": "boolean"
      },
      "name": "instant_payment",
      "selected_by_default": null,
      "translated": null
    },
    "invoice_at_approval": {
      "column": {
        "default": false,
        "name": "invoice_at_approval",
        "null": false,
        "type": "boolean"
      },
      "name": "invoice_at_approval",
      "selected_by_default": null,
      "translated": null
    },
    "live_enabled": {
      "column": {
        "default": false,
        "name": "live_enabled",
        "null": false,
        "type": "boolean"
      },
      "name": "live_enabled",
      "selected_by_default": null,
      "translated": null
    },
    "location_id": {
      "column": {
        "default": null,
        "name": "location_id",
        "null": true,
        "type": "uuid"
      },
      "name": "location_id",
      "selected_by_default": null,
      "translated": null
    },
    "maximum_participants": {
      "column": {
        "default": null,
        "name": "maximum_participants",
        "null": true,
        "type": "integer"
      },
      "name": "maximum_participants",
      "selected_by_default": null,
      "translated": null
    },
    "minimum_participants": {
      "column": {
        "default": null,
        "name": "minimum_participants",
        "null": true,
        "type": "integer"
      },
      "name": "minimum_participants",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "number_of_students": {
      "column": {
        "default": null,
        "name": "number_of_students",
        "null": true,
        "type": "integer"
      },
      "name": "number_of_students",
      "selected_by_default": null,
      "translated": null
    },
    "number_of_teachers": {
      "column": {
        "default": null,
        "name": "number_of_teachers",
        "null": true,
        "type": "integer"
      },
      "name": "number_of_teachers",
      "selected_by_default": null,
      "translated": null
    },
    "politics_enabled": {
      "column": {
        "default": false,
        "name": "politics_enabled",
        "null": false,
        "type": "boolean"
      },
      "name": "politics_enabled",
      "selected_by_default": null,
      "translated": null
    },
    "prevent_re_sign_ups": {
      "column": {
        "default": false,
        "name": "prevent_re_sign_ups",
        "null": false,
        "type": "boolean"
      },
      "name": "prevent_re_sign_ups",
      "selected_by_default": null,
      "translated": null
    },
    "responsible_id": {
      "column": {
        "default": null,
        "name": "responsible_id",
        "null": true,
        "type": "uuid"
      },
      "name": "responsible_id",
      "selected_by_default": null,
      "translated": null
    },
    "show_on_overview": {
      "column": {
        "default": false,
        "name": "show_on_overview",
        "null": false,
        "type": "boolean"
      },
      "name": "show_on_overview",
      "selected_by_default": null,
      "translated": null
    },
    "starts_at": {
      "column": {
        "default": null,
        "name": "starts_at",
        "null": true,
        "type": "datetime"
      },
      "name": "starts_at",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "open",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "timely_cancellation_days": {
      "column": {
        "default": null,
        "name": "timely_cancellation_days",
        "null": true,
        "type": "integer"
      },
      "name": "timely_cancellation_days",
      "selected_by_default": null,
      "translated": null
    },
    "vimeo_live_event_identifier": {
      "column": {
        "default": null,
        "name": "vimeo_live_event_identifier",
        "null": true,
        "type": "string"
      },
      "name": "vimeo_live_event_identifier",
      "selected_by_default": null,
      "translated": null
    },
    "header_image_path": {
      "column": null,
      "name": "header_image_path",
      "selected_by_default": false,
      "translated": null
    },
    "translated_activity_type": {
      "column": null,
      "name": "translated_activity_type",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Activity",
  "collectionKey": "activities",
  "collectionName": "activities",
  "i18nKey": "activity",
  "camelizedLower": "activity",
  "name": "Activity",
  "nameDasherized": "activity",
  "pluralName": "activities",
  "ransackable_associations": [
    {
      "className": "ActivityGroup",
      "collectionName": "activity_groups",
      "foreignKey": "activity_group_id",
      "name": "activity_group",
      "macro": "belongs_to",
      "resource_name": "ActivityGroup",
      "through": null
    },
    {
      "className": "ActivityParticipantTypeRule",
      "collectionName": "activity_participant_type_rules",
      "foreignKey": "activity_id",
      "name": "activity_participant_type_rules",
      "macro": "has_many",
      "resource_name": "ActivityParticipantTypeRule",
      "through": null
    },
    {
      "className": "ActivityParticipant",
      "collectionName": "activity_participants",
      "foreignKey": "activity_id",
      "name": "activity_participants",
      "macro": "has_many",
      "resource_name": "ActivityParticipant",
      "through": null
    },
    {
      "className": "ActivityPermittedContactType",
      "collectionName": "activity_permitted_contact_types",
      "foreignKey": "activity_id",
      "name": "activity_permitted_contact_types",
      "macro": "has_many",
      "resource_name": "ActivityPermittedContactType",
      "through": null
    },
    {
      "className": "ActivitySurvey",
      "collectionName": "activity_surveys",
      "foreignKey": "activity_id",
      "name": "activity_surveys",
      "macro": "has_many",
      "resource_name": "ActivitySurvey",
      "through": null
    },
    {
      "className": "AgendaItemElement",
      "collectionName": "agenda_item_elements",
      "foreignKey": "agenda_item_id",
      "name": "agenda_item_elements",
      "macro": "has_many",
      "resource_name": "AgendaItemElement",
      "through": "agenda_items"
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "agenda_id",
      "name": "agenda_items",
      "macro": "has_many",
      "resource_name": "AgendaItem",
      "through": "agendas"
    },
    {
      "className": "Agenda",
      "collectionName": "agendas",
      "foreignKey": "activity_id",
      "name": "agendas",
      "macro": "has_many",
      "resource_name": "Agenda",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "cancellation_price_id",
      "name": "cancellation_price",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "SubActivity",
      "collectionName": "sub_activities",
      "foreignKey": "parent_id",
      "name": "child_sub_activities",
      "macro": "has_many",
      "resource_name": "SubActivity",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "child_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": "child_sub_activities"
    },
    {
      "className": "Agenda",
      "collectionName": "agendas",
      "foreignKey": "current_agenda_id",
      "name": "current_agenda",
      "macro": "belongs_to",
      "resource_name": "Agenda",
      "through": null
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "current_agenda_item_id",
      "name": "current_agenda_item",
      "macro": "belongs_to",
      "resource_name": "AgendaItem",
      "through": null
    },
    {
      "className": "Election",
      "collectionName": "elections",
      "foreignKey": "activity_id",
      "name": "elections",
      "macro": "has_many",
      "resource_name": "Election",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "extra_product_id",
      "name": "extra_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "header_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "header_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "header_image_attachment"
    },
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscore",
      "macro": "belongs_to",
      "resource_name": "Highscore",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "location_id",
      "name": "location",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "member_price_id",
      "name": "member_price",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "non_member_price_id",
      "name": "non_member_price",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "SubActivity",
      "collectionName": "sub_activities",
      "foreignKey": "child_id",
      "name": "parent_sub_activities",
      "macro": "has_many",
      "resource_name": "SubActivity",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "parent_id",
      "name": "parents",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": "parent_sub_activities"
    },
    {
      "className": "Plan",
      "collectionName": "plans",
      "foreignKey": "plan_id",
      "name": "plan",
      "macro": "belongs_to",
      "resource_name": "Plan",
      "through": null
    },
    {
      "className": "ProposalType",
      "collectionName": "proposal_types",
      "foreignKey": "activity_id",
      "name": "proposal_types",
      "macro": "has_many",
      "resource_name": "ProposalType",
      "through": null
    },
    {
      "className": "Proposal",
      "collectionName": "proposals",
      "foreignKey": "activity_id",
      "name": "proposals",
      "macro": "has_many",
      "resource_name": "Proposal",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "relational_member_price_id",
      "name": "relational_member_price",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "RequiredMetadatum",
      "collectionName": "required_metadata",
      "foreignKey": "resource_id",
      "name": "required_metadatum",
      "macro": "has_one",
      "resource_name": "RequiredMetadatum",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "responsible_id",
      "name": "responsible",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "surveys",
      "macro": "has_many",
      "resource_name": "Survey",
      "through": "activity_surveys"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "activity_id",
      "name": "teams",
      "macro": "has_many",
      "resource_name": "Team",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "activity_group_id",
      "column": {
        "default": null,
        "name": "activity_group_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "activity_surveys_count",
      "column": {
        "default": 0,
        "name": "activity_surveys_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "activity_type",
      "column": {
        "default": "activity",
        "name": "activity_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "allow_public_sign_up",
      "column": {
        "default": true,
        "name": "allow_public_sign_up",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "authenticate_anonymously",
      "column": {
        "default": true,
        "name": "authenticate_anonymously",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "authenticate_with_email",
      "column": {
        "default": true,
        "name": "authenticate_with_email",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "authenticate_with_uni_c",
      "column": {
        "default": true,
        "name": "authenticate_with_uni_c",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "auto_approve_participants",
      "column": {
        "default": false,
        "name": "auto_approve_participants",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "cancellation_deadline_days",
      "column": {
        "default": null,
        "name": "cancellation_deadline_days",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "cancellation_price_id",
      "column": {
        "default": null,
        "name": "cancellation_price_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "check_in_starts_at",
      "column": {
        "default": null,
        "name": "check_in_starts_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "current_agenda_id",
      "column": {
        "default": null,
        "name": "current_agenda_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "current_agenda_item_id",
      "column": {
        "default": null,
        "name": "current_agenda_item_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "default_participant_type",
      "column": {
        "default": "participant",
        "name": "default_participant_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "election_description",
      "column": {
        "default": null,
        "name": "election_description",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "election_enabled",
      "column": {
        "default": false,
        "name": "election_enabled",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "election_title",
      "column": {
        "default": null,
        "name": "election_title",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "ends_at",
      "column": {
        "default": null,
        "name": "ends_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "extra_product_id",
      "column": {
        "default": null,
        "name": "extra_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "guests_per_participant",
      "column": {
        "default": null,
        "name": "guests_per_participant",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "highscore_id",
      "column": {
        "default": null,
        "name": "highscore_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "include_question_products_at_transmission",
      "column": {
        "default": false,
        "name": "include_question_products_at_transmission",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "instant_payment",
      "column": {
        "default": false,
        "name": "instant_payment",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "invoice_at_approval",
      "column": {
        "default": false,
        "name": "invoice_at_approval",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "live_enabled",
      "column": {
        "default": false,
        "name": "live_enabled",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "location_id",
      "column": {
        "default": null,
        "name": "location_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "maximum_participants",
      "column": {
        "default": null,
        "name": "maximum_participants",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "member_price_id",
      "column": {
        "default": null,
        "name": "member_price_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "minimum_participants",
      "column": {
        "default": null,
        "name": "minimum_participants",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "non_member_price_id",
      "column": {
        "default": null,
        "name": "non_member_price_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "number_of_students",
      "column": {
        "default": null,
        "name": "number_of_students",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "number_of_teachers",
      "column": {
        "default": null,
        "name": "number_of_teachers",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_activity_group_id",
      "column": {
        "default": null,
        "name": "old_activity_group_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_cancellation_price_id",
      "column": {
        "default": null,
        "name": "old_cancellation_price_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_current_agenda_id",
      "column": {
        "default": null,
        "name": "old_current_agenda_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_current_agenda_item_id",
      "column": {
        "default": null,
        "name": "old_current_agenda_item_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_extra_product_id",
      "column": {
        "default": null,
        "name": "old_extra_product_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_highscore_id",
      "column": {
        "default": null,
        "name": "old_highscore_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_location_id",
      "column": {
        "default": null,
        "name": "old_location_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_member_price_id",
      "column": {
        "default": null,
        "name": "old_member_price_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_non_member_price_id",
      "column": {
        "default": null,
        "name": "old_non_member_price_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_plan_id",
      "column": {
        "default": null,
        "name": "old_plan_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_relational_member_price_id",
      "column": {
        "default": null,
        "name": "old_relational_member_price_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_responsible_id",
      "column": {
        "default": null,
        "name": "old_responsible_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "participant_number",
      "column": {
        "default": 0,
        "name": "participant_number",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "plan_id",
      "column": {
        "default": null,
        "name": "plan_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "politics_enabled",
      "column": {
        "default": false,
        "name": "politics_enabled",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "prevent_re_sign_ups",
      "column": {
        "default": false,
        "name": "prevent_re_sign_ups",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "relational_member_price_id",
      "column": {
        "default": null,
        "name": "relational_member_price_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "responsible_id",
      "column": {
        "default": null,
        "name": "responsible_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "show_on_overview",
      "column": {
        "default": false,
        "name": "show_on_overview",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "starts_at",
      "column": {
        "default": null,
        "name": "starts_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "open",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "timely_cancellation_days",
      "column": {
        "default": null,
        "name": "timely_cancellation_days",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vimeo_live_event_identifier",
      "column": {
        "default": null,
        "name": "vimeo_live_event_identifier",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "agenda_id",
      "name": "agenda_items",
      "macro": "has_many",
      "resource_name": "AgendaItem",
      "through": "agendas"
    },
    {
      "className": "AgendaItemElement",
      "collectionName": "agenda_item_elements",
      "foreignKey": "agenda_item_id",
      "name": "agenda_item_elements",
      "macro": "has_many",
      "resource_name": "AgendaItemElement",
      "through": "agenda_items"
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "cancellation_price_id",
      "name": "cancellation_price",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "child_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": "child_sub_activities"
    },
    {
      "className": "Agenda",
      "collectionName": "agendas",
      "foreignKey": "current_agenda_id",
      "name": "current_agenda",
      "macro": "belongs_to",
      "resource_name": "Agenda",
      "through": null
    },
    {
      "className": "AgendaItem",
      "collectionName": "agenda_items",
      "foreignKey": "current_agenda_item_id",
      "name": "current_agenda_item",
      "macro": "belongs_to",
      "resource_name": "AgendaItem",
      "through": null
    },
    {
      "className": "Election",
      "collectionName": "elections",
      "foreignKey": "activity_id",
      "name": "elections",
      "macro": "has_many",
      "resource_name": "Election",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "extra_product_id",
      "name": "extra_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscore",
      "macro": "belongs_to",
      "resource_name": "Highscore",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "location_id",
      "name": "location",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "member_price_id",
      "name": "member_price",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "non_member_price_id",
      "name": "non_member_price",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "relational_member_price_id",
      "name": "relational_member_price",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "RequiredMetadatum",
      "collectionName": "required_metadata",
      "foreignKey": "resource_id",
      "name": "required_metadatum",
      "macro": "has_one",
      "resource_name": "RequiredMetadatum",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "responsible_id",
      "name": "responsible",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    }
  ],
  "paramKey": "activity",
  "primaryKey": "id"
}

/** Frontend model for Activity. */
export default class Activity extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {number} */
  activitySurveysCount() {
    return this.readAttributeUnderscore("activity_surveys_count")
  }

  /** @returns {boolean} */
  hasActivitySurveysCount() {
    const value = this.activitySurveysCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  activityType() {
    return this.readAttributeUnderscore("activity_type")
  }

  /** @returns {boolean} */
  hasActivityType() {
    const value = this.activityType()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  allowPublicSignUp() {
    return this.readAttributeUnderscore("allow_public_sign_up")
  }

  /** @returns {boolean} */
  hasAllowPublicSignUp() {
    const value = this.allowPublicSignUp()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  authenticateAnonymously() {
    return this.readAttributeUnderscore("authenticate_anonymously")
  }

  /** @returns {boolean} */
  hasAuthenticateAnonymously() {
    const value = this.authenticateAnonymously()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  authenticateWithUniC() {
    return this.readAttributeUnderscore("authenticate_with_uni_c")
  }

  /** @returns {boolean} */
  hasAuthenticateWithUniC() {
    const value = this.authenticateWithUniC()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  authenticateWithEmail() {
    return this.readAttributeUnderscore("authenticate_with_email")
  }

  /** @returns {boolean} */
  hasAuthenticateWithEmail() {
    const value = this.authenticateWithEmail()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  autoApproveParticipants() {
    return this.readAttributeUnderscore("auto_approve_participants")
  }

  /** @returns {boolean} */
  hasAutoApproveParticipants() {
    const value = this.autoApproveParticipants()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  cancellationDeadlineDays() {
    return this.readAttributeUnderscore("cancellation_deadline_days")
  }

  /** @returns {boolean} */
  hasCancellationDeadlineDays() {
    const value = this.cancellationDeadlineDays()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  checkInStartsAt() {
    return this.readAttributeUnderscore("check_in_starts_at")
  }

  /** @returns {boolean} */
  hasCheckInStartsAt() {
    const value = this.checkInStartsAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  currentAgendaId() {
    return this.readAttributeUnderscore("current_agenda_id")
  }

  /** @returns {boolean} */
  hasCurrentAgendaId() {
    const value = this.currentAgendaId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  currentAgendaItemId() {
    return this.readAttributeUnderscore("current_agenda_item_id")
  }

  /** @returns {boolean} */
  hasCurrentAgendaItemId() {
    const value = this.currentAgendaItemId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  defaultParticipantType() {
    return this.readAttributeUnderscore("default_participant_type")
  }

  /** @returns {boolean} */
  hasDefaultParticipantType() {
    const value = this.defaultParticipantType()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  description() {
    return this.readAttributeUnderscore("description")
  }

  /** @returns {boolean} */
  hasDescription() {
    const value = this.description()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  electionDescription() {
    return this.readAttributeUnderscore("election_description")
  }

  /** @returns {boolean} */
  hasElectionDescription() {
    const value = this.electionDescription()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  electionEnabled() {
    return this.readAttributeUnderscore("election_enabled")
  }

  /** @returns {boolean} */
  hasElectionEnabled() {
    const value = this.electionEnabled()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  electionTitle() {
    return this.readAttributeUnderscore("election_title")
  }

  /** @returns {boolean} */
  hasElectionTitle() {
    const value = this.electionTitle()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  endsAt() {
    return this.readAttributeUnderscore("ends_at")
  }

  /** @returns {boolean} */
  hasEndsAt() {
    const value = this.endsAt()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  guestsPerParticipant() {
    return this.readAttributeUnderscore("guests_per_participant")
  }

  /** @returns {boolean} */
  hasGuestsPerParticipant() {
    const value = this.guestsPerParticipant()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  highscoreId() {
    return this.readAttributeUnderscore("highscore_id")
  }

  /** @returns {boolean} */
  hasHighscoreId() {
    const value = this.highscoreId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  includeQuestionProductsAtTransmission() {
    return this.readAttributeUnderscore("include_question_products_at_transmission")
  }

  /** @returns {boolean} */
  hasIncludeQuestionProductsAtTransmission() {
    const value = this.includeQuestionProductsAtTransmission()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  instantPayment() {
    return this.readAttributeUnderscore("instant_payment")
  }

  /** @returns {boolean} */
  hasInstantPayment() {
    const value = this.instantPayment()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  invoiceAtApproval() {
    return this.readAttributeUnderscore("invoice_at_approval")
  }

  /** @returns {boolean} */
  hasInvoiceAtApproval() {
    const value = this.invoiceAtApproval()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  liveEnabled() {
    return this.readAttributeUnderscore("live_enabled")
  }

  /** @returns {boolean} */
  hasLiveEnabled() {
    const value = this.liveEnabled()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  locationId() {
    return this.readAttributeUnderscore("location_id")
  }

  /** @returns {boolean} */
  hasLocationId() {
    const value = this.locationId()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  maximumParticipants() {
    return this.readAttributeUnderscore("maximum_participants")
  }

  /** @returns {boolean} */
  hasMaximumParticipants() {
    const value = this.maximumParticipants()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  minimumParticipants() {
    return this.readAttributeUnderscore("minimum_participants")
  }

  /** @returns {boolean} */
  hasMinimumParticipants() {
    const value = this.minimumParticipants()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  numberOfStudents() {
    return this.readAttributeUnderscore("number_of_students")
  }

  /** @returns {boolean} */
  hasNumberOfStudents() {
    const value = this.numberOfStudents()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  numberOfTeachers() {
    return this.readAttributeUnderscore("number_of_teachers")
  }

  /** @returns {boolean} */
  hasNumberOfTeachers() {
    const value = this.numberOfTeachers()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  politicsEnabled() {
    return this.readAttributeUnderscore("politics_enabled")
  }

  /** @returns {boolean} */
  hasPoliticsEnabled() {
    const value = this.politicsEnabled()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  preventReSignUps() {
    return this.readAttributeUnderscore("prevent_re_sign_ups")
  }

  /** @returns {boolean} */
  hasPreventReSignUps() {
    const value = this.preventReSignUps()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  responsibleId() {
    return this.readAttributeUnderscore("responsible_id")
  }

  /** @returns {boolean} */
  hasResponsibleId() {
    const value = this.responsibleId()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  showOnOverview() {
    return this.readAttributeUnderscore("show_on_overview")
  }

  /** @returns {boolean} */
  hasShowOnOverview() {
    const value = this.showOnOverview()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  startsAt() {
    return this.readAttributeUnderscore("starts_at")
  }

  /** @returns {boolean} */
  hasStartsAt() {
    const value = this.startsAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  timelyCancellationDays() {
    return this.readAttributeUnderscore("timely_cancellation_days")
  }

  /** @returns {boolean} */
  hasTimelyCancellationDays() {
    const value = this.timelyCancellationDays()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  vimeoLiveEventIdentifier() {
    return this.readAttributeUnderscore("vimeo_live_event_identifier")
  }

  /** @returns {boolean} */
  hasVimeoLiveEventIdentifier() {
    const value = this.vimeoLiveEventIdentifier()

    return this._isPresent(value)
  }

  /** @returns {any} */
  headerImagePath() {
    return this.readAttributeUnderscore("header_image_path")
  }

  /** @returns {boolean} */
  hasHeaderImagePath() {
    const value = this.headerImagePath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedActivityType() {
    return this.readAttributeUnderscore("translated_activity_type")
  }

  /** @returns {boolean} */
  hasTranslatedActivityType() {
    const value = this.translatedActivityType()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  adminRegister(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "admin_register",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  countTeamSurveys(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "count_team_surveys",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  duplicate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "duplicate",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  findNextAgendaItem(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "find_next_agenda_item",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  findPreviousAgendaItem(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "find_previous_agenda_item",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  missingTeamSurveys(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "missing_team_surveys",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  nextAgendaItem(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "next_agenda_item",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  previousAgendaItem(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "previous_agenda_item",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  recalculateParticipantTypes(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "recalculate_participant_types",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  userRegister(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "user_register",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  vimeoLiveEventEmbedHtml(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "vimeo_live_event_embed_html",
        primaryKey: this.primaryKey(),
        collectionName: "activities",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./agenda-item.js").default>} */
  agendaItems() {
    return new Collection(
      {
        reflectionName: "agenda_items",
        model: this,
        modelClass: AgendaItem
      },
      {
        params: {
          through: {
            model: "Activity",
            id: this.primaryKey(),
            reflection: "agenda_items"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./agenda-item.js").default>>} */
  loadAgendaItems() {
    return this._loadHasManyReflection(
      {
        reflectionName: "agenda_items",
        model: this,
        modelClass: AgendaItem
      },
      {
        params: {
          through: {
            model: "Activity",
            id: this.primaryKey(),
            reflection: "agenda_items"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./agenda-item.js").default>>} */
  ensureAgendaItemsLoaded() {
    return this.ensureAssociationLoaded("agenda_items")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./agenda-item-element.js").default>} */
  agendaItemElements() {
    return new Collection(
      {
        reflectionName: "agenda_item_elements",
        model: this,
        modelClass: AgendaItemElement
      },
      {
        params: {
          through: {
            model: "Activity",
            id: this.primaryKey(),
            reflection: "agenda_item_elements"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./agenda-item-element.js").default>>} */
  loadAgendaItemElements() {
    return this._loadHasManyReflection(
      {
        reflectionName: "agenda_item_elements",
        model: this,
        modelClass: AgendaItemElement
      },
      {
        params: {
          through: {
            model: "Activity",
            id: this.primaryKey(),
            reflection: "agenda_item_elements"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./agenda-item-element.js").default>>} */
  ensureAgendaItemElementsLoaded() {
    return this.ensureAssociationLoaded("agenda_item_elements")
  }

  /** @returns {import("./product.js").default | null} */
  cancellationPrice() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "cancellation_price"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadCancellationPrice() {
    if (!("cancellationPriceId" in this)) throw new Error("Foreign key method wasn't defined: cancellationPriceId")

    const id = this.cancellationPriceId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "cancellation_price",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureCancellationPriceLoaded() {
    return this.ensureAssociationLoaded("cancellation_price")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./activity.js").default>} */
  children() {
    return new Collection(
      {
        reflectionName: "children",
        model: this,
        modelClass: Activity
      },
      {
        params: {
          through: {
            model: "Activity",
            id: this.primaryKey(),
            reflection: "children"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./activity.js").default>>} */
  loadChildren() {
    return this._loadHasManyReflection(
      {
        reflectionName: "children",
        model: this,
        modelClass: Activity
      },
      {
        params: {
          through: {
            model: "Activity",
            id: this.primaryKey(),
            reflection: "children"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./activity.js").default>>} */
  ensureChildrenLoaded() {
    return this.ensureAssociationLoaded("children")
  }

  /** @returns {import("./agenda.js").default | null} */
  currentAgenda() {
    return this._readBelongsToReflection({modelClass: Agenda, reflectionName: "current_agenda"})
  }

  /** @returns {Promise<import("./agenda.js").default | null>} */
  loadCurrentAgenda() {
    if (!("currentAgendaId" in this)) throw new Error("Foreign key method wasn't defined: currentAgendaId")

    const id = this.currentAgendaId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "current_agenda",
        model: this,
        modelClass: Agenda
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./agenda.js").default | null>} */
  ensureCurrentAgendaLoaded() {
    return this.ensureAssociationLoaded("current_agenda")
  }

  /** @returns {import("./agenda-item.js").default | null} */
  currentAgendaItem() {
    return this._readBelongsToReflection({modelClass: AgendaItem, reflectionName: "current_agenda_item"})
  }

  /** @returns {Promise<import("./agenda-item.js").default | null>} */
  loadCurrentAgendaItem() {
    if (!("currentAgendaItemId" in this)) throw new Error("Foreign key method wasn't defined: currentAgendaItemId")

    const id = this.currentAgendaItemId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "current_agenda_item",
        model: this,
        modelClass: AgendaItem
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./agenda-item.js").default | null>} */
  ensureCurrentAgendaItemLoaded() {
    return this.ensureAssociationLoaded("current_agenda_item")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./election.js").default>} */
  elections() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["activity_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "elections",
        model: this,
        modelClass: Election
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./election.js").default>>} */
  loadElections() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["activity_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "elections",
        model: this,
        modelClass: Election
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./election.js").default>>} */
  ensureElectionsLoaded() {
    return this.ensureAssociationLoaded("elections")
  }

  /** @returns {import("./product.js").default | null} */
  extraProduct() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "extra_product"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadExtraProduct() {
    if (!("extraProductId" in this)) throw new Error("Foreign key method wasn't defined: extraProductId")

    const id = this.extraProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "extra_product",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureExtraProductLoaded() {
    return this.ensureAssociationLoaded("extra_product")
  }

  /** @returns {import("./highscore.js").default | null} */
  highscore() {
    return this._readBelongsToReflection({modelClass: Highscore, reflectionName: "highscore"})
  }

  /** @returns {Promise<import("./highscore.js").default | null>} */
  loadHighscore() {
    if (!("highscoreId" in this)) throw new Error("Foreign key method wasn't defined: highscoreId")

    const id = this.highscoreId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "highscore",
        model: this,
        modelClass: Highscore
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./highscore.js").default | null>} */
  ensureHighscoreLoaded() {
    return this.ensureAssociationLoaded("highscore")
  }

  /** @returns {import("./contact.js").default | null} */
  location() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "location"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadLocation() {
    if (!("locationId" in this)) throw new Error("Foreign key method wasn't defined: locationId")

    const id = this.locationId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "location",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureLocationLoaded() {
    return this.ensureAssociationLoaded("location")
  }

  /** @returns {import("./product.js").default | null} */
  memberPrice() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "member_price"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadMemberPrice() {
    if (!("memberPriceId" in this)) throw new Error("Foreign key method wasn't defined: memberPriceId")

    const id = this.memberPriceId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "member_price",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureMemberPriceLoaded() {
    return this.ensureAssociationLoaded("member_price")
  }

  /** @returns {import("./product.js").default | null} */
  nonMemberPrice() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "non_member_price"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadNonMemberPrice() {
    if (!("nonMemberPriceId" in this)) throw new Error("Foreign key method wasn't defined: nonMemberPriceId")

    const id = this.nonMemberPriceId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "non_member_price",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureNonMemberPriceLoaded() {
    return this.ensureAssociationLoaded("non_member_price")
  }

  /** @returns {import("./product.js").default | null} */
  relationalMemberPrice() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "relational_member_price"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadRelationalMemberPrice() {
    if (!("relationalMemberPriceId" in this)) throw new Error("Foreign key method wasn't defined: relationalMemberPriceId")

    const id = this.relationalMemberPriceId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "relational_member_price",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureRelationalMemberPriceLoaded() {
    return this.ensureAssociationLoaded("relational_member_price")
  }

  /** @returns {import("./required-metadatum.js").default | null} */
  requiredMetadatum() {
    return this._readHasOneReflection({modelClass: RequiredMetadatum, reflectionName: "required_metadatum"})
  }

  /** @returns {Promise<import("./required-metadatum.js").default | null>} */
  loadRequiredMetadatum() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["resource_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "required_metadatum",
        model: this,
        modelClass: RequiredMetadatum
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./required-metadatum.js").default | null>} */
  ensureRequiredMetadatumLoaded() {
    return this.ensureAssociationLoaded("required_metadatum")
  }

  /** @returns {import("./contact.js").default | null} */
  responsible() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "responsible"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadResponsible() {
    if (!("responsibleId" in this)) throw new Error("Foreign key method wasn't defined: responsibleId")

    const id = this.responsibleId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "responsible",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureResponsibleLoaded() {
    return this.ensureAssociationLoaded("responsible")
  }
}
